var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content",domProps:{"innerHTML":_vm._s(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }